<template>
    <div class="auth-wrapper auth-v1">
        <div class="row w-100">
            <Overlay class="col-md-4 col-lg-4 offset-md-4 offset-lg-4" :show="showLoading">
                <!-- Login v1 -->
                <b-card class="mb-0">
                    <b-link class="brand-logo">
                        <vuexy-logo />

                        <img :src="logo" style="max-width: 160px">
                    </b-link>


                    <transition name="fade">
                        <b-form-group v-if="organizations.length > 0">
                            <div class="d-flex justify-content-between">
                                <label for="login-organization">{{ $t('Page(Login):Component(Label):organization') }}</label>
                            </div>
                            <v-select
                                :placeholder="$t('Page(Login):Component(Placeholder):organization')"
                                :options="organizations"
                                v-model="organization"
                                label="title"
                            />
                        </b-form-group>
                    </transition>

                    <!-- submit button -->
                    <Button class="btn-block" @click="selectAndLogin" :disabled="invalid">
                        {{ $t('Page(Login):Component(Button):sign_in') }}
                    </Button>

                    <div class="text-center pt-1">
                        <a @click="backToLogin" class="text-center text-primary text-decoration-underline">Back to login</a>
                    </div>
                </b-card>

                <div class="text-center mt-1 d-flex justify-content-between">
                    <PrivacyPolicyLink/>
                    <GoogleApiUserDataPolicyLink/>
                </div>
            </Overlay>
        </div>
    </div>
</template>
<script>
/* eslint-disable global-require */
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {Button} from "@core/components/common";
import Overlay from "@core/components/common/Overlay.vue";
import {
    BLink, BFormGroup, BCard,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import PrivacyPolicyLink from "@core/components/common/PrivacyPolicyLink.vue";
import useJwt from "@/auth/jwt/useJwt";
import GoogleApiUserDataPolicyLink from "@core/components/common/GoogleApiUserDataPolicyLink.vue";
import { $themeConfig } from '@themeConfig'

export default {
    directives: {
        'height-fade': heightFade,
    },
    components: {
        GoogleApiUserDataPolicyLink,
        PrivacyPolicyLink,
        Button, Overlay, BLink, BFormGroup, BCard, VuexyLogo, vSelect,
    },
    data() {
        return {
            showLoading: false,
            organization: null,
            logo: $themeConfig.app.brandingLogo,
        }
    },
    computed: {
        organizations() {
            return this.$store.state.user.organizations;
        },
        invalid() {
            return this.organization === null;
        }
    },
    methods: {
        backToLogin() {
            useJwt.clear();
            this.$router.push({name: 'auth-login'});
        },
        selectAndLogin() {
            this.showLoading = true;
            this.$store
                .dispatch('selectOrganization', this.organization)
                .then(() => {
                    this.showLoading = false;
                    this.$router.push({name: 'homepage'})
                })
            ;
        },
    },
    created() {
        if (this.organizations.length === 0) {
            this.$router.push({name: 'auth-login'});
        } else if (this.organizations.length === 1) {
            this.organization = this.organizations[0];
            this.selectAndLogin();
        }
    }
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
